module.exports = __webpack_public_path__ + "img/cover-contact.7895b048.jpg";